import { Component, OnInit } from '@angular/core';
import { PlayerErrorComponent } from '../player-prompts/player-error-dialog/player-error.component';
import { DialogService } from 'src/app/shared/services/dialog.service';

@Component({
  selector: 'app-session-timeout',
  template: '<div class="session-timeout-container"></div>',
  styles: [
    `
      .session-timeout-container {
        width: 100vw;
        height: 100vh;
        background-color: black;
      }
    `,
  ],
})
export class SessionTimeoutComponent implements OnInit {
  constructor(private dialogService: DialogService) {}

  ngOnInit(): void {
    this.dialogService.openDialog(PlayerErrorComponent, {
      data: {
        message: 'Oops! An error occurred. Please login again.',
        buttonLabel: 'Try Again',
        redirectPath: '/',
        errorCode: 'Unknown',
        forceLogout: true,
      },
      disableClose: true,
    });
  }
}
